import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Sidebar from './components/Sidebar';
import Dashboard from './routes/Dashboard';
import WindFarms from './routes/WindFarms';
import Turbines from './routes/Turbines';
import TurbineDetail from './routes/TurbineDetail';
import TurbinesList from './routes/TurbinesList';
import InspectionsList from './routes/InspectionsList';
import InspectionViewer from './routes/InspectionViewer';
import ProjectViewer from './routes/ProjectViewer';
import FileUploader from './components/FileUploader';

const AppLayout = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f5f7fa;
`;

const MainContent = styled.div`
  margin-left: 250px;
  flex: 1;
  min-height: 100vh;
`;

const UserBar = styled.div`
  background: white;
  padding: 16px 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
`;

const UserEmail = styled.span`
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
`;

const LogoutButton = styled.button`
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
  }
`;

const AppContent: React.FC = () => {
  const { user, logout } = useAuth();

  if (!user) {
    return <Login />;
  }

  return (
    <Router>
      <AppLayout>
        <Sidebar />
        <MainContent>
          <UserBar>
            <UserEmail>{user.email}</UserEmail>
            <LogoutButton onClick={logout}>Çıkış Yap</LogoutButton>
          </UserBar>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/wind-farms" element={<WindFarms />} />
            <Route path="/wind-farms/:farmId/turbines" element={<Turbines />} />
            <Route path="/turbines/:turbineId" element={<TurbineDetail />} />
            <Route path="/turbines" element={<TurbinesList />} />
            <Route path="/project/:projectId" element={<ProjectViewer />} />
            <Route path="/inspections" element={<InspectionsList />} />
            <Route path="/inspection" element={<InspectionViewer />} />
            <Route path="/statistics" element={<div style={{ padding: '30px' }}>Statistics (Coming Soon)</div>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </MainContent>
      </AppLayout>
    </Router>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;
